export const mergeConfig = (defaults, cms) => {
    let res = Object.assign(Object.assign({}, defaults), (cms || {}));
    if (res.noneOptionText === "") {
        res.noneOptionText = defaults.noneOptionText;
    }
    return res;
};
//# sourceMappingURL=mergeConfig.js.map